module.exports = __webpack_public_path__ + "img/morning-usage-active-icon.cddcde26.svg";